import axios from 'axios';
import authHeader from "@/service/auth-header";

class CompanyService {

    async getCompanies() {
        return await axios.get(`/api/company`, {headers: authHeader()})
    }

    async getCompany(companyId) {
        return await axios.get(`/api/company/specific/${companyId}`, {headers: authHeader()})
    }

    async createCompany(data) {
        return await axios.post(`/api/company`, data, {headers: authHeader()});
    }

    async updateCompany(companyId, data) {
        return await axios.put(`/api/company/${companyId}`, data, {headers: authHeader()});
    }

    async checkEmail(companyId, data) {
        return await axios.post(`/api/company/check/email/${companyId}`, data, {headers: authHeader()});
    }

    async deleteCompany(companyId) {
        return await axios.delete(`/api/company/${companyId}`, {headers: authHeader()});
    }

    async getCompanyConfiguration(companyId) {
        return await axios.get(`/api/companyconfig/${companyId}`, {headers: authHeader()})
    }

    async updateCompanyConfiguration(companyId, data) {
        return await axios.put(`/api/companyconfig/${companyId}`, data, {headers: authHeader()});
    }

    async loadDefaultUnpaidTemplates(companyId) {
        return await axios.post(`/api/companyconfig/load/unpaidtemplates/${companyId}`, null, {headers: authHeader()});
    }

    async authenticateOAuth2(companyId) {
        return await axios.get(`/api/companyconfig/auth/oauth2/${companyId}`, {headers: authHeader()})
    }

    async hasOAuth2Credential(companyId) {
        return await axios.get(`/api/companyconfig/auth/hasoauth2/${companyId}`, {headers: authHeader()})
    }

    async deleteOAuth2Credential(companyId) {
        return await axios.delete(`/api/companyconfig/auth/oauth2/${companyId}`, {headers: authHeader()})
    }

    async entraGetAuthUrl(companyId) {
        return await axios.get(`/api/companyconfig/entra/oauth2/${companyId}`, {headers: authHeader()})
    }

    async hasEntraOAuth2Token(companyId) {
        return await axios.get(`/api/companyconfig/entra/hasoauth2/${companyId}`, {headers: authHeader()})
    }

    async deleteEntraOAuth2Token(companyId) {
        return await axios.delete(`/api/companyconfig/entra/oauth2/${companyId}`, {headers: authHeader()})
    }

    async intuitGetAuthUrl(companyId) {
        return await axios.get(`/api/companyconfig/intuit/oauth2/${companyId}`, {headers: authHeader()})
    }

    async hasIntuitOAuth2Token(companyId) {
        return await axios.get(`/api/companyconfig/intuit/hasoauth2/${companyId}`, {headers: authHeader()})
    }

    async deleteIntuitOAuth2Token(companyId) {
        return await axios.delete(`/api/companyconfig/intuit/oauth2/${companyId}`, {headers: authHeader()})
    }

    async getIntuitAccountTypes(companyId) {
        return await axios.get(`/api/companyconfig/intuit/accounts/${companyId}`, {headers: authHeader()})
    }
}

export default new CompanyService();
